import expect from './expect';

// eslint-disable-next-line complexity
export function objectCompare(objA, objB) {
    if (expect(objA).isBasic()) {
        if (expect(objA).isNumber() && isNaN(objA)) {
            return expect(objB).isNumber() && isNaN(objB);
        }

        return objA === objB;
    }

    if (expect(objA).isArray()) {
        if (!expect(objB).isArray()) return false;
        if (objA.length !== objB.length) return false;

        // 找到说明不相等
        return !objA.find((item, index) => !objectCompare(item, objB[index]));
    }

    if (expect(objA).isObj()) {
        if (!expect(objB).isObj()) return false;
        if (Object.keys(objA).length !== Object.keys(objB).length) return false;

        // 找到说明不相等
        return !Object.keys(objA).find(key => !objectCompare(objA[key], objB[key]));
    }

    return true;
}
